import "/acf-blocks/block-history/block-history.scss"

class BlockHistory {
  constructor() {
    this.blocks = document.querySelectorAll('.js-history-block')
    this.currentYear = null
    this.events()
  }

  events() {
    if (!this.blocks.length) return

    const currentYearSpan = document.querySelector('.js-current-year')
    const trackElement = document.querySelector('.js-block-history-track')
    const blockElement = document.querySelector('.block-history')
    const progressLine = document.querySelector('.js-track-progress')

    this.initScrollTracking(currentYearSpan, trackElement, blockElement, progressLine)
  }

  initScrollTracking(currentYearSpan, trackElement, blockElement, progressLine) {
    // Throttle scroll events for better performance
    let ticking = false
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.updateCurrentYearOnScroll(currentYearSpan, trackElement, blockElement, progressLine)
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    
    // Store reference for cleanup
    this.scrollHandler = handleScroll
    
    // Initial check
    this.updateCurrentYearOnScroll(currentYearSpan, trackElement, blockElement, progressLine)
  }

  updateCurrentYearOnScroll(currentYearSpan, trackElement, blockElement, progressLine) {
    const blockRect = blockElement.getBoundingClientRect()
    const trackRect = trackElement.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    
    // Calculate when animation should start and end
    const blockTop = blockRect.top
    const blockBottom = blockRect.bottom
    const blockHeight = blockRect.height
    
    // Animation starts when top of block hits top of viewport
    // Animation ends when bottom of block hits bottom of viewport
    const animationStart = 0 // when blockTop === 0
    const animationEnd = viewportHeight // when blockBottom === viewportHeight
    
    // Calculate scroll progress (0 to 1)
    let scrollProgress = 0
    
    if (blockTop <= animationStart && blockBottom >= animationEnd) {
      // Block is fully in viewport - calculate progress based on how much has scrolled
      const scrolledDistance = Math.abs(blockTop)
      const totalScrollDistance = blockHeight - viewportHeight
      scrollProgress = Math.min(scrolledDistance / totalScrollDistance, 1)
    } else if (blockTop > animationStart) {
      // Block hasn't reached viewport yet
      scrollProgress = 0
    } else if (blockBottom < animationEnd) {
      // Block has scrolled past viewport
      scrollProgress = 1
    }
    
    // Calculate available track height (using viewport height units as per CSS)
    const trackHeight = trackRect.height
    
    // Calculate the position for the currentYearSpan within the track
    const maxMovement = trackHeight - currentYearSpan.offsetHeight
    const currentPosition = scrollProgress * maxMovement
    
    // Apply the transform to move the currentYearSpan
    currentYearSpan.style.transform = `translate(-50%,${currentPosition}px)`
    
    // Update progress line height to fill from top of track to currentYearSpan position
    const progressLineHeight = currentPosition + (currentYearSpan.offsetHeight / 2)
    progressLine.style.height = `${progressLineHeight}px`
    
    // Update year text based on when span top aligns with block tops
    this.updateYearBasedOnSpanPosition(currentYearSpan, trackElement, currentPosition)
  }
  
  updateYearBasedOnSpanPosition(currentYearSpan, trackElement, spanPositionInTrack) {
    const trackRect = trackElement.getBoundingClientRect()
    
    // Calculate the absolute position of the span's top edge in viewport coordinates
    const spanTopInViewport = trackRect.top + spanPositionInTrack
    
    // Find which block's top aligns with or has been passed by the span's top
    let activeBlock = null
    let activeYear = null
    
    // Iterate through blocks in reverse to find the last one that has been passed
    for (let i = this.blocks.length - 1; i >= 0; i--) {
      const block = this.blocks[i]
      const blockRect = block.getBoundingClientRect()
      
      // Check if the span's top has reached or passed this block's top
      // We add a small threshold to handle floating point comparisons
      if (spanTopInViewport >= blockRect.top - 1) {
        activeBlock = block
        activeYear = parseInt(block.dataset.year)
        break
      }
    }
    
    // If no block found (span is above all blocks), use the first block's year
    if (!activeBlock && this.blocks.length > 0) {
      activeBlock = this.blocks[0]
      activeYear = parseInt(activeBlock.dataset.year)
    }
    
    // Update year if it has changed
    if (activeYear && this.currentYear !== activeYear) {
      this.currentYear = activeYear
      currentYearSpan.innerText = activeYear.toString()
      
      // Optional: Add a CSS class for styling transitions
      currentYearSpan.classList.add('year-updated')
      setTimeout(() => {
        currentYearSpan.classList.remove('year-updated')
      }, 300)
    }
  }

  // Cleanup method to remove event listeners
  destroy() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler)
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
	new BlockHistory()
})